import { EnvironmentSettings } from "@/environment/environment";

const environment = process.env.NODE_ENV || 'production';

export interface IEnvironmentService {
    getServicePath(servicekey: string): string;
}

export class EnvironmentService implements IEnvironmentService {
    public getServicePath(servicekey: string): string {
        if (fixtureMode) {
            var environmentSettings = new EnvironmentSettings();
            var path = environmentSettings.getFixtureSettings().find(x => x.key == servicekey).path;
            return apiUrlBase + path;
        }
        else {
            var environmentSettings = new EnvironmentSettings();
            var path = environmentSettings.getLiveSettings().find(x => x.key == servicekey).path;
            return apiUrlBase + path;
        }
    }

}
